// import AvatarDropDown  from "@/components/custom/AvatarDropDown";
// import {  
//   Bell,
//   CircleUserRound } from "lucide-react";
import Icon from '@/img/spotlight_logo.webp';

import { useAuth } from "./auth";
import { useApiFetch } from './helper/apiFetch';
import { useTranslate } from "@/helper/translate";

import { Moon, Sun } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useTheme } from "@/components/theme-provider"


export function SiteHeader() {
  const { translate } = useTranslate();
  const { logout } = useAuth();
  const apiFetch = useApiFetch();
  const { theme, setTheme } = useTheme();

  const Logout = async() => {

    const res = await apiFetch(`/Auth/Logout`, {
        method: "POST"
       
        
      });

      if (!res.ok) {
        

      }
      else
      {
        logout();
      }

  
   
  }


  return (
    <header className="sticky top-0 z-50 w-full border-b bg-black text-white px-3 pt-3 pb-2">
      <div className="flex justify-between">
        <div>
          <img src={Icon} className="ml-3 h-8"/>
        </div>
        {/* <div className="flex gap-3">
          <Bell color="white" fill="white" />
         
          <AvatarDropDown />
        </div> */}

         <div className="flex gap-3">
          <Button
            size="icon"
            className="relative rounded-full opacity-30 hover:opacity-60"
            title={`Current theme: ${theme}`}
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          >
            <Sun className="h-[1.0rem] w-[1.0rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
            <Moon className="absolute h-[1.0rem] w-[1.0rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
            <span className="sr-only">Toggle theme</span>
          </Button>

          <button className="relative rounded-3xl border-2 border-solid border-white/25 text-xs uppercase px-4 py-2 hover:bg-white/15" onClick={Logout}>{translate("auth.logout")}</button>
        </div>
      </div>
    </header>
  )

}